import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const eventConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EVENTS_BY_GROUP_SUCCESS:
            return {
                ...state,
                eventsByGroups: action.payload,
            };
        case actionTypes.GET_EVENT_PROCESSES:
            return {
                ...state,
                refDataEventProcess: action.payload,
            };
        case actionTypes.GET_EVENT_PROCESSES_ORDER:
            return {
                ...state,
                refDataEventProcessOrders: action.payload,
            };
        case actionTypes.GET_REF_DATA_EVENT_WIDGET_DATA:
            return {
                ...state,
                widgetEvent: action.payload.records,
            };
        case actionTypes.GET_REF_DATA_EVENT_MONITORING_DATA: {
            return {
                ...state,
                rowData: action.payload.records,
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: action.payload.columns,
                },
            };
        }
        case actionTypes.GET_ALL_TRIGGER_EVENTS_SUCCESS: {
            return {
                ...state,
                triggerEvents: action.payload,
            };
        }
        default:
            return state;
    }
};

export default eventConfigurationReducer;
